import Head from "next/head"

import Another from "../../components/another-component"
import Button from "../../components/button"
import data from "../../components/data"
import { PythonPrerequisite } from "../../components/info"
import {
  courseDataToSchema,
  schemaElementFromSchema,
} from "../../components/utils"

const Course = () => {
  const courseId = "p-wd-be"
  const schema = courseDataToSchema(data, courseId)
  const courseInstances = schema.courseInstances
  const schemaElement = schemaElementFromSchema(schema)
  return (
    <div>
      <Head>
        <title>Tinklalapių kūrimas (backend) su Python | Pirmas kodas</title>
        <meta
          name="description"
          content="Tinklalapių kūrimo (backend) su Python kursas. Jo metu susipažinsite su Python tinklalapių kūrimo frameworkais (FastAPI, Django, Flask) ir įvaldysite pasirinktąjį."
        />
      </Head>
      {schemaElement}

      <article className="prose dark:prose-invert">
        <div>
          <h1>Tinklalapių kūrimas (backend) su Python</h1>
          <div>
            <h3>Tikslinė auditorija</h3>
            <p>
              Kursas skirtas norintiem kurti tinklalapių backend. Jei mėgstate
              duomenis, verslo logiką, duomenų bazes, Jums neįdomu tai, kokia
              spalva bus nuspalvinti mygtukai, šis kursas būtent Jums.
            </p>
          </div>
          <PythonPrerequisite />
          <div>
            <h3>Temos</h3>
            <ul>
              <li>RESTful API</li>
              <li>Flask</li>
              <li>Django</li>
              <li>FastAPI</li>
              <li>Databases</li>
              <li>ORM</li>
              <li>Baigiamasis darbas</li>
            </ul>
          </div>
        </div>
        {courseInstances ? (
          <>
            <h2>Artimiausios grupės</h2>
            {courseInstances.map((instance) => {
              return Another(instance, data.links.generalRegistrationForm)
            })}
          </>
        ) : (
          <Button href={data.links.generalRegistrationForm} />
        )}
      </article>
    </div>
  )
}

export default Course
